import React from 'react';


export default class BackToTop extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
 
        }
    }

     componentDidMount(){
    }

    backToTop = () =>{
        const scrollToTop = () => {
            const c = document.documentElement.scrollTop || document.body.scrollTop;
            if (c > 0) {
              window.requestAnimationFrame(scrollToTop);
              window.scrollTo(0, c - c / 8);
            }
          };
          scrollToTop();
    }


     render() { 
       return (
          <div className='backToTopButton' onClick={this.backToTop} >
                <i className='material-icons' style={{  fontSize:70, color:''}}>arrow_upward</i>
         </div>
        );
       }
}